import { RequiredTranslationsTemplate } from '.'

const ca: RequiredTranslationsTemplate = {
  meta: {
    localeName: 'Català',
  },
  home: {
    title: 'AVÍS DE PRODUCTE - ROCKRIDER XC500S',
    description:
      'Gràcies per comprar una bicicleta de muntanya (MTB) ROCKRIDER XC500S. Hem detectat un possible punt dèbil a la forquilla davantera. Aquest defecte només afecta algunes bicicletes. Et demanem que introdueixis els 30 dígits del número de traçabilitat de la teva bicicleta per comprovar si està afectada per aquest avís de producte:',
    form: {
      title: 'Si us plau, indica les dades següents:',
      fields: {
        serialNumber: 'Número de traçabilitat de la bicicleta',
        serialNumberFamily: 'N° série (début)',
        firstName: 'Nom',
        lastName: 'Cognoms',
        email: 'Correu electrònic',
        phone: 'Telèfon',
        country: 'País',
        submit: 'Validar',
        choose: 'Tria...',
      },
      errors: {
        requiredField: 'Ce champ est requis',
        unknownSerialNumber: 'Numéro de Série inconnu',
        provide6Numbers: 'Attention, 6 chiffres sont nécessaires',
      },
      confirmations: {
        good: {
          title: 'La teva bicicleta no es veu afectada',
          p1: "T'informem que la teva bicicleta no està afectada per aquest avís de producte. Pots continuar gaudint-la normalment.",
          p2: 'Et demanem disculpes pels inconvenients que t’hàgim pogut causar.',
          p3: 'Salutacions cordials,',
          p4: 'L’equip de Decathlon',
        },
        defective: {
          title: 'Per desgràcia, la teva bicicleta està afectada per aquest defecte',
          p1: 'Et demanem que deixis de fer servir immediatament aquesta bicicleta i que contactis amb la botiga Decathlon més propera perquè et canviïn la forquilla.',
          p2: 'Si us plau, tingues en compte que no podràs fer servir la bicicleta uns quants dies, durant la reparació. De totes maneres, pots estar segur que farem tot el possible per minimitzar aquest termini. T’aconsellem que consultis directament al taller de la botiga Decathlon que hagis triat per tenir una estimació del termini de reparació.',
          p3: 'Per trobar el Taller Decathlon que tens més a prop de casa:',
          decathlonLocatorLink: 'https://www.decathlon.fr/store-locator',
          p4: 'Més avall trobaràs el "Document de devolució del client" que has de presentar al nostre tècnic quan vagis al taller:',
          p5: 'Per a més informació, contacta amb el nostre centre d’atenció al client específic per a aquest producte, trucant al telèfon 0 805 38 38 49, que és gratuït si es truca des del territori de França metropolitana (està disponible de dilluns a divendres de les 9:00 a les 19:00 hores), o escrivint un correu electrònic a l’adreça rappel.decathlon@fandi.fr.',
        },
      },
    },
    findTheSerialNumber: {
      title: 'On pots trobar el número de traçabilitat de la bicicleta:',
      description:
        'El número de 30 dígits està imprès a la part inferior del quadre de la bicicleta, a prop de la caixa del pedaler i dels pedals. Mira la imatge següent.',
    },
  },
}

export default ca
